import Calcs from '@/views/calcs/calcs'

export default {
  path: '/calcs',
  redirect: '/calcs/index',
  name: 'calcs',
  meta: {
    auth: {
      redirect: {
        name: 'calcs.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Cálculos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'calcs.index',
    component: Calcs,
    meta: {
      auth: true,
      label: 'Calcular'
    }
  }]
}
